<style lang="scss" scoped>
  .coms {
    height: 100vh;
    background-color: #efeff5;
    .title {
      padding: 5px 10px;
      font-size: 14px;
      text-align: left;
      color: #999;
    }
    .content {
      background-color: #fff;
      .content-footer {
        padding: 20px 10px;
      }
      .defaultbtn {
        .btn {
          width: 48%;
          height: 32px;
          font-size: 15px;
        }
        .btn-l {
          border: 1px solid #eee;
        }
        .btn-r {
          background-color: #1c89ea;
          color: #fff;
        }
      }
      .tips {
        margin-top: 15px;
        text-align: left;
        color: red;
        font-size: 14px;
      }
    }
    .coms-success {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background-color: #fff;
      padding-top: 13.33vw;
      flex-flow: column;
      align-items: center;
    }
    .coms-success-status {
      text-align: center;
      color: #0f0;
      font-size: 54px;
    }
    .coms-success-tips {
      text-align: center;
      font-size: 14px;
      line-height: 34px;
      color: #333;
    }
    .coms-success-tips > p > span,
    .coms-success-tips > p {
      font-size: 14px;
    }
  }
</style>
<template>
  <div class="coms">
    <div class="title" :style="{'padding-top':utils.checkIsApp() ? (utils.isIphoneX()?'45px':'35px') : '5px'}">创建医院</div>
    <div class="content">
      <van-field
        v-model="hospital.comName"
        required
        label="医院全称:"
        placeholder="请输入您所在医院的全称"
        input-align="right"
      />
      <van-field
        v-model="hospital.comTypeName"
        @click="openType('1')"
        required
        readonly
        label="医院性质:"
        placeholder="请选择"
        input-align="right"
      />
      <van-field
        v-model="hospital.categoryName"
        @click="openType('2')"
        required
        readonly
        label="医院类型:"
        placeholder="请选择"
        input-align="right"
      />
      <van-field
        v-model="hospital.gradeName"
        @click="openType('3')"
        required
        readonly
        label="医院等级:"
        placeholder="请选择"
        input-align="right"
      />
      <van-field
        v-model="hospitalAddress"
        @click="openType('0')"
        required
        readonly
        label="所在地区:"
        placeholder="请选择"
        input-align="right"
      />
      <div class="content-footer">
        <div class="defaultbtn df-between">
          <div
            class="btn df-center btn-l"
            @click="_back"
          >取消</div>
          <div
            class="btn df-center btn-r"
            @click="submitHospital"
          >确定</div>
        </div>
        <div class="tips">提醒：请不要创建类似医院，否则可能导致数据不会纳入统计！</div>
      </div>
    </div>
    <van-popup
      v-model="showBase"
      round
      position="bottom"
      class="region-popup"
    >
      <van-picker
        :title="pickerTitle"
        show-toolbar
        :columns="pickerList"
        @confirm="handleConfirmBase"
        @cancel="handleCancelBase"
        :default-index="defaultIndex"
        value-key="name"
      />
    </van-popup>

    <div
      v-if="isAudit"
      class="coms-success"
    >
      <div class="coms-success-status"><van-icon name="checked" /></div>
      <div class="coms-success-tips">
        <p>创建#{{hospital.comName}}#成功，</p>
        <p>新创建医院参与此次学习考试须通过平台审核</p>
        <p>敬请稍等！等不及了？请联系<a
            href="tel:400-969-7756"
            style="color:#09f"
          >400-969-7756</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapGetters, mapActions } from 'vuex'
  export default {
    props: {
      formObj: {
        type: Object,
        default: ()=>{},
      },
      hospitalName: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        defaultIndex: 0,
        areaTreeList: [], // 所在地区数据
        comTypeList: [], // 医院性质数据
        categoryList: [], // 医院类型数据
        gradeList: [], // 医院等级数据
        isAudit: false,
        hospital: {
          comName: '',
          contactMobile: '',
          cityName: '',
          cityCode: '',
          provinceName: '',
          provinceCode: '',
          areaName: '',
          districtCode: '',
          comTypeName: '',
          comType: '',
          categoryName: '',
          category: '',
          gradeName: '',
          grade: '',
          comeFrom: 7, // 对应感控工作间后台客户服务管理——医院列表的注册渠道 品宣默认为7
        },
        showBase: false,
        isType: '1',
      }
    },
    components: {
    },
    computed: {
      ...mapGetters([
        'getClassCode',
        'getSubmitHospital',
        'getAddress',
        'getAreaHospitalByParam',
        'getAreaTree',
      ]),
      hospitalAddress: {
        get() {
          return `${this.hospital.provinceName}${this.hospital.cityName}${this.hospital.areaName}`
        },
        set(value) {
          // 如果需要反向解析可以在这里处理
        },
      },
      pickerTitle() {
        return this.isType == '0' ? '请选择所在地区' : this.isType == '1' ? '请选择医院性质' : this.isType == '2' ? '请选择医院类型' : '请选择医院等级'
      },
      pickerList() {
        return this.isType == '0' ? this.areaTreeList : this.isType == '1' ? this.comTypeList : this.isType == '2' ? this.categoryList : this.gradeList
      },
    },
    mounted() {
      this.$store.dispatch('getAreaTree', {})
      this.hospital.comName = this.hospitalName
      // this.hospital.comName = this.$route.query.hospitalName || ''
    },
    methods: {
      _back() {
        this.cnzzStat('取消创建医院', '点击取消创建医院按钮')
        // 关闭创建医院的页面
        // this.$router.back()
        this.$emit('handleBack')
      },
      handleCancelBase() {
        this.showBase = false
      },
      handleConfirmBase(value) {
        console.log('当前选择的值',value)
        this.showBase = false
        if (this.isType == '0') {
          this.handleConfirm(value)
          return
        }
        if (this.isType == '1') {
          this.hospital.comTypeName = value.name
          this.hospital.comType = value.id
          return
        }
        if (this.isType == '2') {
          this.hospital.categoryName = value.name;
          this.hospital.category = value.id;
          return
        }
        if (this.isType == '3') {
          this.hospital.gradeName = value.name;
          this.hospital.grade = value.id;
          return
        }
      },
      handleConfirm: _.throttle(
        function (value) {
          console.log(value,'所在地区的值')
          this.getAreaTree.data.forEach((item) => {
            if (value[0] == item.name) {
              this.hospital.provinceCode = item.id
            }
            item.children.forEach((items) => {
              if ( value[0] + value[1] == item.name + items.name ) {
                this.hospital.cityCode = items.id
              }
              items.children.forEach((itemss) => {
                if ( value[0] + value[1] + value[2] == item.name + items.name + itemss.name ) {
                  this.hospital.districtCode = itemss.id
                }
              })
            })
          })
          this.hospital.provinceName = value[0]
          this.hospital.cityName = value[1]
          this.hospital.areaName = value[2]
        },
        10,
        { trailing: false }
      ),
      openType(type) {
        this.isType = type
        if (type == '0') {
          this.showBase = true
        }
        if ('1' == type) {
          this.$store.dispatch('classCode', { classCode: 'hospital_type' })
        } else if ('2' == type) {
          this.$store.dispatch('classCode', { classCode: 'hospital_category' })
        } else {
          this.$store.dispatch('classCode', { classCode: 'hospital_grade' })
        }
      },
      submitHospital: _.throttle(
        function () {
          this.cnzzStat('确定创建医院', '点击创建医院确定按钮')
          if (
            !this.hospital.comName ||
            !this.hospital.cityCode ||
            !this.hospital.provinceCode ||
            !this.hospital.comType ||
            !this.hospital.category ||
            !this.hospital.grade
          ) {
            this.$toast("您有必填信息未填写!");
            return false
          }
          this.hospital.contactMobile = this.formObj.phone
          this.hospital.contact = this.formObj.username
          // if (this.$route.query.sceneId && this.$route.query.isStudy) {
          //   this.hospital.comeFrom = 5
          // } else if ( this.$route.query.sceneId && this.$route.query.isQuestionnairesurvey ) {
          //   this.hospital.comeFrom = 6
          // } else {
          //   this.hospital.comeFrom = 2
          // }
          console.log(this.hospital, 'this._.cloneDeep(this.hospital)')
          this.$store.dispatch('submitHospital', this._.cloneDeep(this.hospital))
        },
        1000,
        { trailing: false }
      ),
    },
    watch: {
      getClassCode () {
        console.log(this.getClassCode,'字典数据')
        this.showBase = true
        // 深拷贝并过滤掉 children 字段（picker组件数据有children会出现多列）
        let pickerList = JSON.parse(JSON.stringify(this.getClassCode.data)).map(item => {
          delete item.children
          return item
        })
        // 根据类型设置列表和 defaultIndex
        if (this.isType == 1) {
          this.comTypeList = pickerList
          // 查找已选择的医院性质的索引
          if (this.hospital.comType) {
            this.defaultIndex = pickerList.findIndex(item => item.id === this.hospital.comType)
            this.defaultIndex = this.defaultIndex === -1 ? 0 : this.defaultIndex
          } else {
            this.defaultIndex = 0
          }
        } else if (this.isType == 2) {
          this.categoryList = pickerList
          // 查找已选择的医院类型的索引
          if (this.hospital.category) {
            this.defaultIndex = pickerList.findIndex(item => item.id === this.hospital.category)
            this.defaultIndex = this.defaultIndex === -1 ? 0 : this.defaultIndex
          } else {
            this.defaultIndex = 0
          }
        } else {
          this.gradeList = pickerList
          // 查找已选择的医院等级的索引
          if (this.hospital.grade) {
            this.defaultIndex = pickerList.findIndex(item => item.id === this.hospital.grade)
            this.defaultIndex = this.defaultIndex === -1 ? 0 : this.defaultIndex
          } else {
            this.defaultIndex = 0
          }
        }
      },
      getAreaTree: function () {
        if (this.getAreaTree.code == 0) {
          this.areaTreeList = JSON.parse(JSON.stringify(this.getAreaTree.data))
          // 查找已选择的省市区索引
          let provinceIndex = 0
          let cityIndex = 0
          let areaIndex = 0
          
          if (this.hospital.provinceCode) {
            provinceIndex = this.areaTreeList.findIndex(item => item.id === this.hospital.provinceCode)
            provinceIndex = provinceIndex === -1 ? 0 : provinceIndex
          }
          
          this.areaTreeList.forEach((v, i) => {
            this.$set(v, 'text', v.name)
            // 为省份级别设置 defaultIndex
            this.$set(v, 'defaultIndex', i === provinceIndex ? provinceIndex : 0)
            
            if (v.children) {
              // 如果是当前选中的省份，查找城市索引
              if (i === provinceIndex && this.hospital.cityCode) {
                cityIndex = v.children.findIndex(item => item.id === this.hospital.cityCode)
                cityIndex = cityIndex === -1 ? 0 : cityIndex
              }
              
              v.children.forEach((v1, i1) => {
                this.$set(v1, 'text', v1.name)
                // 为城市级别设置 defaultIndex
                this.$set(v1, 'defaultIndex', (i === provinceIndex && i1 === cityIndex) ? cityIndex : 0)
                
                if (v1.children) {
                  // 如果是当前选中的城市，查找区县索引
                  if (i === provinceIndex && i1 === cityIndex && this.hospital.districtCode) {
                    areaIndex = v1.children.findIndex(item => item.id === this.hospital.districtCode)
                    areaIndex = areaIndex === -1 ? 0 : areaIndex
                  }
                  
                  v1.children.forEach((v2, i2) => {
                    this.$set(v2, 'text', v2.name)
                    // 为区县级别设置 defaultIndex
                    this.$set(v2, 'defaultIndex', (i === provinceIndex && i1 === cityIndex && i2 === areaIndex) ? areaIndex : 0)
                    
                    // 第四层有children时picker还会多出一列
                    if (v2.children) {
                      delete v2.children
                    }
                  })
                }
              })
            }
          })
        } else {
          this.$toast(this.getAreaTree.msg)
        }
      },
      getSubmitHospital: function () {
        let _this = this
        if (this.getSubmitHospital.code == 0) {
          // if (this.$route.query.isQuestionnairesurvey == 'questionnairesurvey') {
          //   let hospitalInfo = {
          //     comName: this.hospital.comName,
          //     gradeName: this.hospital.gradeName,
          //     categoryName: this.hospital.categoryName,
          //     comTypeName: this.hospital.comTypeName,
          //   }
          //   localStorage.setItem('hospitalInfo', JSON.stringify(hospitalInfo))
          //   this.$router.back()
          //   return
          // }
          this.$store.dispatch('areaHospitalByParam', {
            comId: this.getSubmitHospital.data.id,
          })
        } else {
          this.$toast({
            message: _this.getSubmitHospital.msg,
            position: 'bottom',
          })
        }
      },
      getAreaHospitalByParam: function () {
        let _this = this
        if (this.getAreaHospitalByParam.code == 0) {
          this.$store.commit('UPDATE_CREATEHOSINFO', {
            ...this.getSubmitHospital.data, // 创建医院成功后的接口返回数据
            comeFrom: this.hospital.comeFrom,
            locationBranchId: this.getAreaHospitalByParam.data[0].id,
          })
          if (this.getSubmitHospital.data.isAudit) {
            this.isAudit = true
          } else {
            // this.$router.back()
            this.$emit('handleBack')
          }
        } else {
          this.$toast({
            message: _this.getAreaHospitalByParam.msg,
            position: 'bottom',
          })
        }
      },
    },
  }
</script>



